import Swal from "sweetalert";
import { logout } from "src/configs/redux/action/userAction";

const ResponseError = (
  err,
  dispatch,
  history,
  message = "internal server error"
) => {
  if (err.response) {
    if (err.response.status === 401) {
      dispatch(logout(history));
      Swal("Session Expired", "", "warning");
    } else {
      Swal(err.response?.data?.message || message, "", "error");
    }
  } else if (err.request) {
    // The request was made but no response was received

    Swal("Error Occured. Please Try Again Later!", "", "error");
    // setLoading(false);
  } else {
    // Something happened in setting up the request that triggered an Error
    Swal("Error Occured. Please Try Again Later!", "", "error");
    // setLoading(false);
  }
};

export default ResponseError;
